import { RefObject, useEffect } from "react";

export type UseOutsideClickArgs = {
  callback: { (): void };
  disabled?: boolean;
  ref: RefObject<HTMLElement>;
};

export const useOutsideClick = ({
  ref,
  callback,
  disabled = false,
}: UseOutsideClickArgs) => {
  const handleClick = (event: Event) => {
    if (!ref.current?.contains(event.target as Node)) {
      callback();
    }
  };

  useEffect(() => {
    if (!disabled) {
      window.addEventListener("mousedown", handleClick);
    }

    return () => {
      if (!disabled) {
        window.removeEventListener("mousedown", handleClick);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, disabled]);
};
export default useOutsideClick;
